import { render, staticRenderFns } from "./AccessSchedules.vue?vue&type=template&id=2031435f&"
import script from "./AccessSchedules.vue?vue&type=script&lang=ts&"
export * from "./AccessSchedules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports